'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectActiveKeyDefault = exports.selectHistoryState = undefined;

var _get2 = require('lodash/fp/get');

var _get3 = _interopRequireDefault(_get2);

var _flow2 = require('lodash/fp/flow');

var _flow3 = _interopRequireDefault(_flow2);

exports.activeLastMatch = activeLastMatch;
exports.browserHasHistory = browserHasHistory;
exports.isNewHistory = isNewHistory;
exports.keyMatch = keyMatch;

var _select = require('./select');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function activeLastMatch(_ref) {
  var activeKey = _ref.activeKey,
      lastKey = _ref.lastKey;
  return activeKey === lastKey;
} // import { find, flow, orderBy, reverse } from 'lodash/fp'


function browserHasHistory(windowHistory) {
  return windowHistory.state && windowHistory.state.id;
}

function isNewHistory(reduxHistory) {
  // const length = getLength(reduxHistory)
  // console.log(browserState.length, length)
  return activeLastMatch(reduxHistory); // && browserState.length === (length - 1)
}

function keyMatch(reduxHistory, windowHistory) {
  return reduxHistory.activeKey === windowHistory.id;
}

var selectHistoryState = exports.selectHistoryState = (0, _get3.default)('history');
var selectActiveKeyDefault = exports.selectActiveKeyDefault = (0, _flow3.default)(selectHistoryState, _select.selectActiveKey);